<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Log Detail</strong>

            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <pre>{{model}}</pre>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Attacker</label><br></b>
                <!-- <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.remote_addr}}</label> -->
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Target</label><br></b>
                <!-- <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.target}}</label> -->
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';

export default {
  data : () => {
    return {
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_login'}); },
    async get( id = this.$route.params) {
      console.log('log.login.detail.vue', 'load item', id);
      try {
        let rs = await Api.Partner_Call('log.login', 'detail', { id : Number(id.id) })

        console.info(rs)
        this.model = rs.body;
        // let rr = await Api.Partner_Call('user', '')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('log.login.detail.vue', 'created'); },
  destroyed() { console.log('log.login.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.login.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
